const state = () => ({
    user: null,
    medicalCourse: null,
    doctorMenu: null,
    schedule: null,
    paymentMethod: null,
    userCoupon: null,
    doctorMemo: null,
    timezoneWithCurrentTime: null,
    recentlyUserConsultations: [],
})

const mutations = {
    setUser(state, value) {
        state.user = value
    },
    setMedicalCourse(state, value) {
        state.medicalCourse = value
    },
    setDoctorMenu(state, value) {
        state.doctorMenu = value
    },
    setSchedule(state, value) {
        state.schedule = value
    },
    setPaymentMethod(state, value) {
        state.paymentMethod = value
    },
    setUserCoupon(state, value) {
        state.userCoupon = value
    },
    setDoctorMemo(state, value) {
        state.doctorMemo = value
    },
    setTimezoneWithCurrentTime(state, value) {
        state.timezoneWithCurrentTime = value
    },
    setRecentlyUserConsultations(state, value) {
        state.recentlyUserConsultations = value
    },
    clearReservation(state) {
        state.user = null
        state.medicalCourse = null
        state.doctorMenu = null
        state.schedule = null
        state.paymentMethod = null
        state.userCoupon = null
        state.doctorMemo = null
        state.timezoneWithCurrentTime = null
        state.recentlyUserConsultations = []
    },
}

const getters = {}
const actions = {}

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
}
